// CompanySection.js
import React from 'react';
import { Carousel } from 'react-bootstrap';
import '../css/CarouselComponent.css';
import { motion } from 'framer-motion';

import { Container, Row, Col, Card } from 'react-bootstrap';
import '../css/CompanySection.css';
import img1 from '../images/Our Company.jpg';
import img2 from '../images/Slider 2webp.webp';
import img3 from '../images/Slider 3webp.webp';
import img4 from '../images/Slider 4webp.webp';
import img5 from '../images/Slider 5webp.webp';
import img6 from '../images/Slider 6webp.webp';
import icon1 from '../images/Strive .png';
import icon2 from '../images/Excellence.png';
import icon3 from '../images/Ensuring Trusted care.png';
const CompanySection = () => {
    const slides = [
        {
            id: 1,
            image: img1,

        },
        {
            id: 2,
            image: img2,

        },

        {
            id: 3,
            image: img3,

        },

        {
            id: 4,
            image: img4,

        },
        {
            id: 5,
            image: img5,

        },
        {
            id: 6,
            image: img6,

        },
    ];
    const cardData = [
        {
            id: 1,
            title: "Striving for Perfection",
            icon: icon1,
        },
        {
            id: 2,
            title: "Delivering Excellence",
            icon: icon2,
        },
        {
            id: 3,
            title: "Ensuring Trusted Care",
            icon: icon3,
        },
    ];
    return (
        <>
            <Carousel interval={3000} fade={true} pause="hover" indicators={true}>
                {slides.map((slide) => (
                    <Carousel.Item key={slide.id} className="carousel-item">
                        {/* Background Image */}

                        <div className="carousel-images-home">
                            <img src={slide.image} alt={`Slide ${slide.id}`} className="img-fluid w-100" loading='lazy' />
                        </div>


                    </Carousel.Item>
                ))}
            </Carousel>

            {/* Three Cards Section */}
            <section className="company-cards-section">
                <Container>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        <Row className="justify-content-center mt-4 company-card-data">
                            {cardData.map((card, index) => (
                                <Col
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={4}
                                    key={card.id}
                                    className="mb-4 px-5"
                                >
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{
                                            duration: 0.5,
                                            delay: index * 0.2, // Stagger effect
                                        }}
                                        viewport={{ once: true }}
                                    >
                                        <Card className="info-card-company shadow h-100">
                                            <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                                <div className="card-iconimg mb-3">
                                                    <img src={card.icon} alt="" className="fas fa-target" loading="lazy"
                                                    />
                                                </div>
                                                <Card.Title>{card.title}</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </motion.div>
                                </Col>
                            ))}
                        </Row>
                    </motion.div>
                </Container>
            </section>

        </>
    );
};

export default CompanySection;